<template>
  <div class="about-yixi-page">
    <p class="title">关于一席</p>
    <p class="text">
      一席是剧场式演讲、结合网络视频传播的媒体平台，2012年成立于北京，已制作“一席·演讲”、“一席·万象”、“一席·枝桠”和“一席·记录”四档视频节目。目前，已有国内外近千位讲者和表演嘉宾登上一席的舞台，网络视频播放量已超过15亿次。
    </p>
    <br />
    <img class="image" src="../../assets/imgs/aboutyixi.png" alt="" />
    <br />
    <p class="title">一席·现场</p>
    <p class="text">
      一席每月会在不同城市举办一次现场活动，一年约10场，每场有8-10位讲者。一席现场的举办主要集中在以下城市：北京、上海、杭州、南京、苏州、武汉、西安、长沙、广州、深圳、厦门、重庆等中心城市。网络视频观看已超过4亿人次，影响观众上千万人。
    </p>
	
	<br />
	<p class="title">一席·万象</p>
	<p class="text">
	是一席的付费节目，希望帮助大家系统、深入地掌握某一领域的知识。邀请了包括王南、梁永安、王芳、李治中、黄晓丹在内的众多讲者嘉宾，涵盖心理学、建筑学、人类学、建筑学、文学、生物学、天文学等多个领域。
	</p>
	
    <br />
    <p class="title">一席·枝桠</p>
    <p class="text">
      是一档谈话节目。邀请了包括崔健、胡德夫、卢冠廷、林志炫、李银河、张大春、金宇澄、詹宏志、周浩在内的众多嘉宾。试图通过谈话接近他们丰富的精神世界。
    </p>
    <br />
    <p class="title">
      一席·记录
    </p>
    <p class="text">
      是一席拍摄的纪录片。
    </p>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.about-yixi-page {
  padding: 40px 50px;
}
.title {
  font-size: 16px;
  font-weight: bold;
  margin: 0 0 10px;
}
.image {
  display: block;
}
.text {
  font-size: 14px;
  color: #333;
  line-height: 24px;
}
</style>
